import { HStack, Text, VStack } from '@genial/components';
import React from 'react';

import { SecuritiesTransferDetailItemNormalized } from '../../../../../store/customerDetail/SecuritiesTransfer/types';
import { TextSkeleton } from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

type BasicInfosProps = Pick<
  SecuritiesTransferDetailItemNormalized,
  | 'solicitationTypeNormalized'
  | 'requestedByWayOfNormalized'
  | 'requestDateTimeNormalized'
  | 'protocolNormalized'
>;

export const BasicInfos: React.FC<BasicInfosProps> = ({
  solicitationTypeNormalized,
  requestedByWayOfNormalized,
  requestDateTimeNormalized,
  protocolNormalized,
}) => {
  return (
    <HStack flex={1} alignItems="center" justifyContent="space-between">
      <VStack space="stack.nano">
        <Text variant="semibold">Transferência</Text>
        <Text>{solicitationTypeNormalized}</Text>
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Solicitado via</Text>
        <Text>{requestedByWayOfNormalized}</Text>
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Solicitado em</Text>
        <Text>{requestDateTimeNormalized}</Text>
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Protocolo</Text>
        <Text>{protocolNormalized}</Text>
      </VStack>
    </HStack>
  );
};

export const BasicInfosLoading: React.FC = () => {
  return (
    <HStack flex={1} alignItems="center" justifyContent="space-between">
      <VStack space="stack.nano">
        <Text variant="semibold">Transferência</Text>
        <TextSkeleton />
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Solicitado via</Text>
        <TextSkeleton />
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Solicitado em</Text>
        <TextSkeleton />
      </VStack>
      <VStack space="stack.nano">
        <Text variant="semibold">Protocolo</Text>
        <TextSkeleton />
      </VStack>
    </HStack>
  );
};
